import styled from 'styled-components';

export const HeaderNav = styled.div`
  height: 8vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 0 1.25rem;
  border-bottom: 1px solid
    ${({ theme }) => theme?.palette?.border || 'black'};
  background: ${({ theme }) =>
    theme?.palette?.background?.paper ||
    theme?.palette?.background?.default ||
    '#ffffff'};
  position: relative;
  z-index: 5; // Make sure it's below the hamburger menu bars (which should be z-index 10+)
`;

export const AlertContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const InfoLinks = styled.h4`
  cursor: pointer;
  margin: 0.25rem 0;
  color: ${({ theme }) =>
    theme?.palette?.text?.primary || '#111'};
`;